var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GameControllerApiFactory } from "@/apis/game-management";
import GoBack from "@/components/GoBack";
import { useApi } from "@/hooks/useApi";
import { Button, Card, Col, Form, Input, message, Row, Select } from "@atom/ui-kit";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
var EditGameManagement = function () {
    var _a;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var form = Form.useForm()[0];
    var id = useParams().id;
    var location = useLocation();
    var tenant = new URLSearchParams(location.search).get("tenant");
    var _b = useApi({
        asyncFunction: GameControllerApiFactory().gamesTenantTenantIdIdGet,
        successCallback: function (response) {
            var _a, _b;
            form.setFieldsValue(__assign(__assign({}, response.data.data), { players: (_b = (_a = response.data.data) === null || _a === void 0 ? void 0 : _a.players) === null || _b === void 0 ? void 0 : _b.map(function (player) { return player.index; }) }));
        },
        errorCallback: function (error) {
            message.error("Error fetching data");
        },
    }), fetchGameManagementById = _b.call, data = _b.data;
    var responseGame = data === null || data === void 0 ? void 0 : data.data;
    var _c = useApi({
        asyncFunction: GameControllerApiFactory().gamesTenantTenantIdIdPut,
        successCallback: function (response) {
            message.success("GameManagement edited successfully");
            navigate("/game-management");
        },
        errorCallback: function (error) {
            message.error("Error editing GameManagement");
        },
    }), callEditGameManagement = _c.call, loading = _c.loading;
    var handleFinish = function (values) {
        if (tenant && id) {
            values.players = responseGame === null || responseGame === void 0 ? void 0 : responseGame.players.filter(function (player) { var _a; return (_a = values.players) === null || _a === void 0 ? void 0 : _a.includes(player.index); }).map(function (player) { return ({
                nickname: player.nickname,
            }); });
            callEditGameManagement({
                gamesTenantTenantIdIdPutRequest: values,
                id: id,
                tenant: tenant,
            });
        }
    };
    useEffect(function () {
        if (tenant && id) {
            fetchGameManagementById({ tenant: tenant, id: id });
        }
        else {
            navigate("/game-management");
            message.error("Error fetching data");
        }
    }, [tenant, id]);
    return (_jsxs(Card, { style: { padding: "20px 0" }, children: [_jsx(GoBack, { title: t("gameManagement.edit.title") }), _jsxs(Form, { form: form, layout: "vertical", onFinish: handleFinish, children: [_jsxs(Row, { gutter: 16, children: [_jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.id"), name: "id", rules: [{ required: true, message: t("gameManagement.edit.id_required") }], children: _jsx(Input, { size: "small", variant: "borderless" }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.table_id"), name: "table_id", children: _jsx(Input, { size: "small", variant: "borderless" }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.players"), name: "players", children: _jsx(Select, { mode: "tags", size: "small", variant: "borderless", style: { width: "100%" }, children: (_a = responseGame === null || responseGame === void 0 ? void 0 : responseGame.players) === null || _a === void 0 ? void 0 : _a.map(function (player, index) { return (_jsx(Select.Option, { value: player.index, children: player.nickname }, index)); }) }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.last_bet_amount"), name: "last_bet_amount", children: _jsx(Input, { size: "small", variant: "borderless", type: "number", min: 0 }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.dealer_position"), name: "dealer_position", children: _jsx(Input, { size: "small", variant: "borderless", type: "number", min: 0 }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.current_turn"), name: "current_turn", children: _jsx(Input, { size: "small", variant: "borderless" }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.community_cards"), name: "community_cards", children: _jsx(Select, { size: "small", variant: "borderless", style: { width: "100%" } }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.pot"), name: "pot", children: _jsx(Input, { size: "small", variant: "borderless", type: "number", min: 0 }) }) }), _jsx(Col, { xs: 12, sm: 12, md: 8, lg: 6, children: _jsx(Form.Item, { label: t("gameManagement.edit.round"), name: "round", children: _jsx(Input, { size: "small", variant: "borderless" }) }) })] }), _jsx(Row, { children: _jsx(Col, { span: 12, children: _jsx(Button, { block: true, buttonType: "primary", htmlType: "submit", loading: loading, children: t("root.save_button") }) }) })] })] }));
};
export default EditGameManagement;
